// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEARCH_IN_ALL = "H\u013eadaj v inzer\u00e1toch (napr. \"tenisky Adidas\", \"Nitra ko\u010d\u00edk\")";
